export enum FeedbackType {
    success = 'success',
    error = 'error',
    warning = 'warning',
    info = 'info',
}



// WEBPACK FOOTER //
// ./src/Components/Feedback/Models/FeedbackType.ts